import { Checkbox } from '@chakra-ui/react'
import { useT } from '~/i18n/use-t'

/**
 * The biometric consent (AC10): never ticked for the member, and it names the provider. From `md` it is a vocdoni-app
 * choice card (bordered, the border turns dark when ticked); on a phone the frame would cost a line of the consent
 * text, so the box itself (solid when ticked) shows the state. A test provider (`publicSettings.testProvider`, E12.9)
 * shows the test-provider consent of copy v8 instead, in the same place.
 */
export const CONSENT_ID = 'consent-biometric'

export function Consent({
  provider,
  checked,
  onChange,
  testProvider = false,
}: {
  provider: string
  checked: boolean
  onChange: (checked: boolean) => void
  testProvider?: boolean
}) {
  const { t } = useT()
  return (
    <Checkbox.Root
      // The input's id goes through `ids` (never an `id` on HiddenInput): Ark points the label's `for` at this id, so a
      // click on the consent text still ticks the box; FaceStep's start hint focuses it by the same id.
      ids={{ hiddenInput: CONSENT_ID }}
      checked={checked}
      onCheckedChange={(e) => onChange(e.checked === true)}
      alignItems='flex-start'
      name='consentBiometric'
      gap={{ base: 2, md: 3 }}
      borderWidth={{ base: 0, md: '1px' }}
      borderColor={checked ? 'fg' : 'border'}
      borderRadius='md'
      p={{ base: 0, md: 4 }}
      cursor='pointer'
    >
      <Checkbox.HiddenInput />
      <Checkbox.Control boxSize='5' mt='0.5' />
      <Checkbox.Label fontSize='md' lineHeight='1.5'>
        {t(testProvider ? 'testProvider.consent' : 'face.consent', { provider })}
      </Checkbox.Label>
    </Checkbox.Root>
  )
}
